import { PaxCheckErrorContainer, PaxCheckGeneralErrorCode } from "api/models";

export enum DataProviderExceptionType {
  Unknown = "Unknown",
  BadRequest = "BadRequest",
  NotEligible = "NotEligible",
  NotProcessable = "NotProcessable",
  NotFound = "NotFound",
  SessionIsLocked = "SessionIsLocked",
  SessionIsFinalised = "SessionIsFinalised",
}

class DataProviderGeneralException extends Error {
  public type: DataProviderExceptionType;
  public message: string;

  constructor(type: DataProviderExceptionType, message?: string | null) {
    super(message || "");
    this.type = type;
    this.message = message || "";
  }

  static fromApi(
    paxCheckError: PaxCheckErrorContainer | undefined
  ): DataProviderGeneralException {
    if (paxCheckError?.generalError) {
      switch (paxCheckError.generalError.code) {
        case PaxCheckGeneralErrorCode.BAD_REQUEST:
          return new DataProviderGeneralException(
            DataProviderExceptionType.BadRequest,
            paxCheckError.generalError.message
          );
        case PaxCheckGeneralErrorCode.BOOKING_CURRENTLY_NOT_PROCESSABLE:
          return new DataProviderGeneralException(
            DataProviderExceptionType.NotEligible,
            paxCheckError.generalError.message
          );
        case PaxCheckGeneralErrorCode.BOOKING_NOT_PROCESSABLE:
          return new DataProviderGeneralException(
            DataProviderExceptionType.NotProcessable,
            paxCheckError.generalError.message
          );
        case PaxCheckGeneralErrorCode.NOT_FOUND:
          return new DataProviderGeneralException(
            DataProviderExceptionType.NotFound,
            paxCheckError.generalError.message
          );
        case PaxCheckGeneralErrorCode.SESSION_IS_LOCKED:
          return new DataProviderGeneralException(
            DataProviderExceptionType.SessionIsLocked,
            paxCheckError.generalError.message
          );
        case PaxCheckGeneralErrorCode.SESSION_FINALISED:
          return new DataProviderGeneralException(
            DataProviderExceptionType.SessionIsFinalised
          );
      }
    }
    return new DataProviderGeneralException(DataProviderExceptionType.Unknown);
  }
}

export default DataProviderGeneralException;
